const customerAccount = `${process.env.baseUrl}/rma/return`;

export default {
    create: `${customerAccount}/create/order_id`,
    confirmation: `${customerAccount}/confirmation`,
    success: `${customerAccount}/success`,
    processing: `${customerAccount}/processing/rma_id`,
    history: `${customerAccount}/sales/order/history/`,
};
